import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoffee } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin, faStackOverflow, faTwitter } from '@fortawesome/free-brands-svg-icons';
import footerData from '../data/footer.json';
export default function Footer() {
  return (
    <footer className="footer" style={{
      backgroundColor: 'var(--footer-bg)',
      color: 'var(--footer-text)',
      padding: 'var(--space-8) 0', /* Compact footer padding */
      marginTop: 'var(--space-10)', /* Compact space from content above */
      borderTop: '1px solid var(--border-primary)',
      position: 'relative',
    }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6 text-center text-md-start mb-6 mb-md-0">
            <div className="footer-social" style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 'var(--space-4)', /* Compact spacing between social links */
              marginBottom: 'var(--space-4)', /* Compact spacing */
            }}>
              <a
                href={footerData.links.github}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit my GitHub profile"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-primary)',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: 'var(--shadow-primary)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary-dark)'; /* Use existing dark variant */
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = 'var(--shadow-primary-hover)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'var(--shadow-primary)';
                }}
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a
                href={footerData.links.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Visit my LinkedIn profile"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-primary)',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: 'var(--shadow-primary)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary-dark)'; /* Use existing dark variant */
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = 'var(--shadow-primary-hover)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'var(--shadow-primary)';
                }}
              >
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a
                href={footerData.links.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Visit my Twitter profile"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-primary)',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: 'var(--shadow-primary)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary-dark)'; /* Use existing dark variant */
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = 'var(--shadow-primary-hover)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'var(--shadow-primary)';
                }}
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href={footerData.links.stackOverflow}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                aria-label="Visit my Stack Overflow profile"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-primary)',
                  color: 'white',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: 'var(--shadow-primary)',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary-dark)'; /* Use existing dark variant */
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = 'var(--shadow-primary-hover)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'var(--color-primary)';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'var(--shadow-primary)';
                }}
              >
                <FontAwesomeIcon icon={faStackOverflow} />
              </a>
              <div
                className="footer-social-link"
                title="Buy me a coffee"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-secondary)',
                  color: 'white',
                  cursor: 'not-allowed',
                  opacity: 0.6,
                  boxShadow: 'var(--shadow-primary)',
                }}
              >
                <FontAwesomeIcon icon={faCoffee} />
              </div>
            </div>
          </div>

          <div className="col-md-6 text-center text-md-end">
            <div className="footer-description" style={{
              fontSize: 'var(--text-sm)', /* Compact size */
              color: 'var(--text-secondary)',
              marginTop: 'var(--space-2)', /* Compact space */
              padding: '0', /* Remove extra padding */
            }}>
              © {footerData.copyrightYear} Copyright:
              <span style={{
                color: 'var(--color-primary)',
                fontWeight: 'var(--font-semibold)',
                marginLeft: 'var(--space-2)',
              }}>
                {footerData.copyright}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
